import axios from "axios"

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001/api",
  headers: {
    "Content-Type": "application/json",
  },
})

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem("token")

    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // Ensure params is always a valid object
    if (config.params === null || config.params === undefined || typeof config.params !== "object") {
      config.params = {}
    }

    // Get organizationId from user context if not in params
    if (!config.params.organizationId) {
      // Get current user from localStorage
      const user = JSON.parse(localStorage.getItem("user") || "{}")
      if (user && user.organizationId) {
        config.params.organizationId = user.organizationId
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Server error codes that mean this browser session can no longer be used
const SESSION_ENDED_NOTICES = {
  ACCOUNT_DISABLED: "Your account has been deactivated. Contact your administrator.",
  ACCOUNT_REMOVED: "Your account has been removed. Contact your administrator.",
  SESSION_INVALID: "Your session has expired. Please sign in again.",
}
const AUTH_ENDPOINTS = ["/auth/login", "/auth/forgot-password", "/auth/reset-password"]
let isEndingSession = false

const endSession = (notice) => {
  if (isEndingSession) return
  isEndingSession = true
  localStorage.removeItem("token")
  localStorage.removeItem("user")
  sessionStorage.setItem("auth_notice", notice)
  window.location.assign("/login")
}

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx
    return response
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx
    const data = error.response?.data
    const notice = SESSION_ENDED_NOTICES[data?.code]
    const isAuthCall = AUTH_ENDPOINTS.some((endpoint) => error.config?.url?.includes(endpoint))
    if (notice && !isAuthCall) {
      endSession(notice)
    }

    const wrapped = new Error(data?.message || data?.error || error.message)
    wrapped.response = error.response
    return Promise.reject(wrapped)
  },
)

export default api

